import { RegionModel, RMHModel, SModel,RMHAnnualModel } from './RegionModel';
import { ZoneModel } from './ZoneModel';
import { DivisionModel } from './DvisionModel';
import { SBUModel } from './SBUModel';
import { productModel } from './ProductModel';
import { CropModel } from './CropModel';
import { BatchModel } from './BatchModel';
import { InvoiceModel } from './InvoiceModel';
import { YearModel } from './YearModel';
import { monthModel } from './MonthModel';
export class DropDownRequest {
    UserId: string;
    Role: string;
    Region: string;
    Zone: string;
    Division: string;
    SBU: string;
    SD: string;
    RMH: string;
    crop: string;
    product: string;
    month:string;
    Flag: string;
    year:number;
    Annual:string;
    Status:string;
    IsBMData:boolean;
    WareHouse: string;
}

export class DropDownResponse {
    region: Array<RegionModel> = new Array<RegionModel>()
    zone: Array<ZoneModel> = new Array<ZoneModel>()
    division: Array<DivisionModel> = new Array<DivisionModel>()
    sbu: Array<SBUModel> = new Array<SBUModel>()
    product: Array<productModel> = new Array<productModel>()
    month:Array<monthModel>=new Array<monthModel>()
    crop: Array<CropModel> = new Array<CropModel>()
    sd: Array<SDModel> = new Array<SDModel>()
    warehouseLocation: Array<WHLocationModel> = new Array<WHLocationModel>()
    rmh: Array<RMHModel> = new Array<RMHModel>()
    batch: Array<BatchModel> = new Array<BatchModel>()
    invoice: Array<InvoiceModel> = new Array<InvoiceModel>()
    year:Array<YearModel>=new Array<YearModel>()
    roleId:any[]
    annual:Array<RMHAnnualModel>=new Array<RMHAnnualModel>()
    status:Array<SModel>=new Array<SModel>()
}

export class RequirmentTypeModel {
    id: number;
    text: string;
}
export class WHLocationModel {
    WHId: string;
    WHName: string;
}
export class SDModel {
    SDCode: string;
    SDName: string;
}
export class StatusModel {
    id: number;
    text: string;
}
export class DesignationModel {
    id: number;
    text: string;
}
export class QuarterTypeModel {
    id: number;
    text: string;
}
